import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  Container,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useAddPhone } from "@/api/addPhone";
import { useAuthContext } from "@/context/AuthContext";
import { useToast } from "@/context/ToastContext";
export const TaskerRegisterPhone = () => {
  const { user } = useAuthContext();
  const [searchParams] = useSearchParams();
  const toast = useToast();
  const navigate = useNavigate();

  const phone = searchParams.get("p");
  const code = searchParams.get("c");

  const [addPhone, result, loading, error] = useAddPhone();

  useEffect(() => {
    if (!phone || !code) {
      toast.error("Missing phone number or verification code");
    }
  }, [phone, code]);

  const handleConfirm = async () => {
    if (!phone || !code) return;
    addPhone({
      phone,
      code,
    });
  };

  const handleCancel = () => {
    navigate("/sendit"); // Navigate back to tasker dashboard
  };

  if (!phone || !code) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ mt: 4 }}>
          <Card sx={{ p: 3 }}>
            <Typography color="error" align="center">
              {error || "Invalid verification link"}
            </Typography>
            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
              <Button variant="contained" onClick={handleCancel}>
                Return to Dashboard
              </Button>
            </Box>
          </Card>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        {result?.success ? (
          <Card sx={{ p: 3 }}>
            <Typography variant="h6" align="center" gutterBottom>
              {phone} verified and added to your account
            </Typography>
            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
              <Button variant="contained" onClick={handleCancel}>
                Continue to Send IT
              </Button>
            </Box>
          </Card>
        ) : (
          <Card sx={{ p: 3 }}>
            <Typography variant="h6" align="center" gutterBottom>
              Hi, {user?.firstName} {user?.lastName}
            </Typography>
            <Typography align="center" paragraph>
              Would you like to verify this phone number and add it to your
              account?
            </Typography>
            <Typography align="center" variant="h6" gutterBottom>
              {phone}
            </Typography>

            {error && (
              <Typography color="error" align="center" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}

            <Box
              sx={{ mt: 3, display: "flex", justifyContent: "center", gap: 2 }}
            >
              <Button
                variant="outlined"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleConfirm}
                disabled={loading}
                startIcon={loading && <CircularProgress size={20} />}
              >
                {loading ? "Verifying..." : "Verify Phone"}
              </Button>
            </Box>
          </Card>
        )}
      </Box>
    </Container>
  );
};
